import { formatBool } from '@/utils/shared';
import dateFormatter from '@/services/formatter_services/date-formatter';

const DEVICE_WIDGETS = Object.freeze({
  DEVICE_WIDGETS: [
    {
      id: 'devices',
      path: 'devices',
      getData: response => response.data.data?.map(item => item.data),
      headers: [
        {
          text: 'Common.matchcode',
          value: 'matchcode'
        },
        {
          text: 'Common.label',
          value: 'label'
        },
        {
          text: 'Dashboard.widgets.devices.headers.currentOwner',
          value: 'currentOwner'
        },
        {
          text: 'Dashboard.widgets.devices.headers.internalContactName',
          value: 'internalContactName'
        },
        {
          text: 'Common.product',
          value: 'productLabel'
        },
        {
          text: 'Common.status',
          value: 'statusLabel'
        },
        {
          text: 'Common.type',
          value: 'typeLabel'
        },
        {
          text: 'Dashboard.widgets.devices.headers.hasMaintenance',
          value: 'hasMaintenance',
          presentWith: formatBool
        },
        {
          text: 'Dashboard.widgets.devices.headers.lastMaintenance',
          value: 'lastMaintenance',
          presentWith: dateFormatter.formatDateToLocaleDateString
        }
      ],
      type: 'TABLE',
      moduleId: 'devices',
      withRouterActionLink: true
    },
    {
      id: 'devicesAmount',
      path: 'devices',
      type: 'VALUE',
      getData: response => response.data.totalHits,
      moduleId: 'devices'
    }
  ]
});

export default DEVICE_WIDGETS;
